module.exports = __webpack_public_path__ + "static/media/monkey_half.86c69d66.png";